import { render, staticRenderFns } from "./PageViewHospitals.vue?vue&type=template&id=844312e4&"
import script from "./PageViewHospitals.vue?vue&type=script&lang=ts&"
export * from "./PageViewHospitals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports